/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React, { useContext, useReducer } from 'react';

const SET_LANGUAGE = 'SET_LANGUAGE';

const CustomerStateContext = React.createContext();
const CustomerDispatchContext = React.createContext();

const CustomerReducer = (state, action) => {
    switch (action.type) {
        case SET_LANGUAGE: {
            return {...state, language: action.payload};
        }
        default: {
            throw new Error(`[CustomerReducer] Unsupported action type: ${action.type}.`);
        }
    }
};


export const CustomerProvider = (props) => {
    const { uid, customerId, language, contactAddress, hasActiveLrp, children, orderType } = props;
    const [state, dispatch] = useReducer(CustomerReducer, {uid, customerId, language, contactAddress, hasActiveLrp, orderType}); /* contactAddress is currently defined only under CRM environment. */

    return (
        <CustomerStateContext.Provider value={state}> 
            <CustomerDispatchContext.Provider value={dispatch}>
                {children}
            </CustomerDispatchContext.Provider>
        </CustomerStateContext.Provider>
    );
};


export const useCustomerState = () => {
    const context = useContext(CustomerStateContext);
    if (context === undefined) {
        throw new Error('useCustomerState must be used within a CustomerProvider.');
    }
    return context;
};


export const useCustomerMutator = () => {
    const dispatch = useContext(CustomerDispatchContext);
    if (!dispatch) {
        throw new Error('useCustomerMutator must be used within a CustomerProvider');
    }
    const setLanguage = (language) => {
        dispatch({type: SET_LANGUAGE, payload: language});
    };
    return [setLanguage];
};
